import {Component, Input, OnInit} from '@angular/core';
import {ConfService} from "../../conf.service";

@Component({
  selector: 'app-database-inf-settings',
  templateUrl: './database-inf-settings.component.html',
  styleUrls: ['./database-inf-settings.component.scss']
})
export class DatabaseInfSettingsComponent implements OnInit {

  constructor(private confPost: ConfService) { }
  databaseSelected: any;
  data: any;
  ngOnInit() {
    this.confPost.getSettingsCRUD('stejas1', 'stejas1')
        .subscribe(data => {
          this.data = data[0];
          if (this.data !== undefined && this.data['partner_settings']){

          }
        });
  }
  update() {
    this.confPost.patchEntityData('services', 'services', 'v1', 'settings', this.data.id, this.data).subscribe( success =>{
      alert('Updation Successful');
    }, err => {
      alert('Error. Please try again.');
    });
  }
}
